import * as React from 'react';

import type {DisplayOptionEntity} from 'nutshell-core/utils';

import {EntityPageAddItemButton} from 'shells/lead-sidebar/entity-page-add-item-button';
import {AccountCardCreateable} from 'shells/peep-cards/account-card/account-card-createable/account-card-createable';

import {analyticsClient} from '../../../analytics-client';

import {getPotentialAccounts} from './utils';
import type {AccountInput} from './utils';

import styles from './account-hierarchy.module.css';

type Props = {
    accountId: string;
    onSelectAccount: (id: string, isParent: boolean) => Promise<any>;
    onCreateAccount: (input: {
        accountInput: AccountInput;
        parentAccountId: string | null | undefined;
        childAccountId: string | null | undefined;
    }) => Promise<any>;
    refetch: () => Promise<any>;
    alreadyAddedAccountIds: string[];
};

export function AddButtons(props: Props) {
    const [isAddingParent, setIsAddingParent] = React.useState<boolean>(false);
    const [isAddingChild, setIsAddingChild] = React.useState<boolean>(false);

    const shouldShowButtons = !isAddingParent && !isAddingChild;

    const trackAddedParent = () => {
        analyticsClient.track(analyticsClient.EVENTS.TRACK_ACCOUNT_HIERARCHY_PARENT_SET_ON_CHILD);
    };

    const trackAddedFirstChild = () => {
        analyticsClient.track(
            analyticsClient.EVENTS.TRACK_ACCOUNT_HIERARCHY_CHILD_ADDED_TO_NEW_PARENT
        );
    };

    const onSelectAccount = (account: DisplayOptionEntity) => {
        props.onSelectAccount(account.id, isAddingParent).then(() => {
            if (isAddingParent) {
                trackAddedParent();
                setIsAddingParent(false);
            } else {
                trackAddedFirstChild();
                setIsAddingChild(false);
            }
        });
    };

    const onCreateAccount = (accountInput: AccountInput) => {
        props
            .onCreateAccount({
                accountInput,
                parentAccountId: isAddingParent ? undefined : props.accountId,
                childAccountId: isAddingParent ? props.accountId : undefined,
            })
            .then(() => {
                if (isAddingParent) {
                    trackAddedParent();
                    setIsAddingParent(false);
                } else {
                    trackAddedFirstChild();
                    setIsAddingChild(false);
                }

                props.refetch();
            });
    };

    return (
        <>
            {shouldShowButtons && (
                <div className={styles.buttons}>
                    <EntityPageAddItemButton
                        sectionEntity='accounts'
                        parentItemText='a parent'
                        onAddItem={() => setIsAddingParent(true)}
                        omitEntityName={true}
                    />
                    <EntityPageAddItemButton
                        sectionEntity='accounts'
                        parentItemText='a child'
                        onAddItem={() => setIsAddingChild(true)}
                        omitEntityName={true}
                    />
                </div>
            )}
            {isAddingParent || isAddingChild ? (
                <AccountCardCreateable
                    onSelectAccount={onSelectAccount}
                    onSubmit={onCreateAccount}
                    onSearchPotentialAccounts={(input: AccountInput) =>
                        getPotentialAccounts({
                            accountInput: input,
                            isAddingParent,
                            accountId: props.accountId,
                            alreadyAddedAccounts: props.alreadyAddedAccountIds,
                        })
                    }
                    onClose={() => {
                        if (isAddingParent) {
                            setIsAddingParent(false);
                        } else {
                            setIsAddingChild(false);
                        }
                    }}
                />
            ) : undefined}
        </>
    );
}
